<!--
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2023-12-22 23:53:33
 * @LastEditors: Merlin
 * @LastEditTime: 2024-06-07 15:31:43
 * @Description: 在特定币时变化图标 
-->
<template>
    <GameSettingsButtonWrapper
        :tool-tip="$t('waves.ProvablyFair')" 
        anchor="top middle"
        self="bottom middle"
        @click="onClick()"
    >
        <IconSvgUse
            size="15px"
            use="icon-fairness-new"
        />
    </GameSettingsButtonWrapper>
</template>

<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';

const t = useTranslation();
// const props = defineProps({
//     modelValue: { // 目前没有用到 
//         type: Boolean,
//         default: false,
//     },
// });

// const emit = defineEmits(['update:modelValue']); 

const onClick = () => {
    // emit('update:modelValue', !props.modelValue);
};

</script>

